import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { v4 as uuid } from "uuid";

import { getClient } from "services";

import enrichEQWithGenerationSeed from "seneca-common/features/exam-questions/utils/enrichEQWithGenerationSeed";

export const BATCH_FETCH_QUESTIONS_QUERY_KEY =
  "short-answer-eq-course-sections";

export default function useBatchFetchQuestions(
  {
    questionIds,
    assignmentId
  }: {
    questionIds: string[];
    assignmentId?: string;
  },
  { enabled }: { enabled: boolean } = { enabled: true }
) {
  const [staticGenerationSeed] = useState<string>(uuid);

  return useQuery({
    queryKey: [
      BATCH_FETCH_QUESTIONS_QUERY_KEY,
      ...questionIds.sort(),
      assignmentId
    ],
    queryFn: () =>
      getClient("shortAnswerService").batchFetchQuestions(questionIds),
    staleTime: Infinity,
    select: data =>
      data.map(
        enrichEQWithGenerationSeed(assignmentId || staticGenerationSeed)
      ),
    retry: false,
    enabled
  });
}
